import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, DatePicker, Button, message } from 'antd';
import moment from 'moment';
import { renewTransaction } from '../TransactionActions';
import { MSG_ERROR } from '../../../../../constants';
import { getApiErrorMessage } from '../../../../../utils/httpError';

const FormItem = Form.Item;

const defaultExpiryDate = moment().add(1, 'year');

const RenewTransactionForm = ({ form, transaction, renewTransaction, close }) => {
  const { getFieldDecorator } = form;
  const [loading, setLoading] = useState(false);

  const onSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, fieldsValue) => {
      if (err || !transaction?.transactionId) return;

      const expiryDate = fieldsValue.expiryDate?.toISOString?.();
      if (!expiryDate) {
        message.error('Please select an expiry date.');
        return;
      }

      setLoading(true);
      try {
        await renewTransaction(transaction.transactionId, { expiryDate });
        message.success('Transaction renewed successfully.');
        close();
      } catch (error) {
        message.error(getApiErrorMessage(error, MSG_ERROR));
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <Form>
      <p className="renew-transaction-summary">
        Renew <strong>{transaction?.amount ?? 0}</strong> subscription
        {transaction?.amount === 1 ? '' : 's'} under this transaction.
      </p>
      <FormItem label="Expiry Date" extra="Defaults to one year from today.">
        {getFieldDecorator('expiryDate', {
          initialValue: defaultExpiryDate,
          rules: [{ required: true, message: 'Please select an expiry date.' }]
        })(<DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />)}
      </FormItem>
      <FormItem>
        <Button type="primary" block loading={loading} onClick={onSubmit}>
          {loading ? 'Renewing' : 'Renew'}
        </Button>
      </FormItem>
    </Form>
  );
};

const mapDispatchToProps = { renewTransaction };

export default connect(null, mapDispatchToProps)(Form.create()(RenewTransactionForm));
